import React from 'react';
import FlashbetTicketSelections from '../flashbet-ticket/FlashbetTicketSelections';
import FlashbetTicketTuples from '../flashbet-ticket/FlashbetTicketTuples';

function FlashbetTicketBody(props) {
	
	const ticketData = props.ticketData;
	const frontendType = props.frontendType;
	const aamsEnviroment = props.aamsEnviroment; 
	const user = props.user;
	return <>
		<FlashbetTicketSelections user={user} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />
		{
			ticketData.purchaseType === 'systembets' && (<FlashbetTicketTuples user={user} ticketData={ticketData} frontendType={frontendType} aamsEnviroment={aamsEnviroment} />)
		}
	</>
}

export default FlashbetTicketBody;